(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.VendeyTemplateTransfer = api;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  const SCHEMA = "vendey-pro-template";
  const VERSION = 1;
  const TIPOS = Object.freeze(["ticket-venta", "cotizacion"]);

  function validarTipo(tipo) {
    if (!TIPOS.includes(tipo)) {
      throw new Error("El tipo de plantilla no es compatible con Vendey Pro.");
    }
    return tipo;
  }

  function crearPaquete(tipo, plantilla) {
    return {
      schema: SCHEMA,
      version: VERSION,
      type: validarTipo(tipo),
      exportedAt: new Date().toISOString(),
      template: plantilla && typeof plantilla === "object" ? plantilla : {}
    };
  }

  function serializar(tipo, plantilla) {
    return JSON.stringify(crearPaquete(tipo, plantilla), null, 2);
  }

  function extraer(contenido, tipoEsperado, normalizar) {
    validarTipo(tipoEsperado);
    let datos;
    try {
      datos = typeof contenido === "string" ? JSON.parse(contenido) : contenido;
    } catch (_) {
      throw new Error("El archivo no contiene un JSON válido.");
    }
    if (!datos || typeof datos !== "object" || Array.isArray(datos)) {
      throw new Error("El archivo no contiene una plantilla válida.");
    }
    if (datos.schema && datos.schema !== SCHEMA) {
      throw new Error("El archivo pertenece a otro tipo de configuración.");
    }
    if (datos.type && datos.type !== tipoEsperado) {
      throw new Error(
        tipoEsperado === "cotizacion"
          ? "Selecciona una plantilla de cotización."
          : "Selecciona una plantilla de ticket de venta."
      );
    }
    const plantilla = datos.template && typeof datos.template === "object"
      ? datos.template
      : datos;
    return typeof normalizar === "function" ? normalizar(plantilla) : plantilla;
  }

  return {
    SCHEMA,
    VERSION,
    TIPOS,
    crearPaquete,
    serializar,
    extraer
  };
});
